import React from "react";
import { OverlayTrigger, Popover } from "react-bootstrap";

const ToolTip = ({ position, value, children }) => {
  return (
    <OverlayTrigger
      placement={position}
      delay={{ show: 250, hide: 400 }}
      overlay={
        <Popover style={{ zIndex: "99999999999999" }} id="popover-basic">
          <Popover.Body>{value}</Popover.Body>
        </Popover>
      }
    >
      {children}
    </OverlayTrigger>
  );
};

export default ToolTip;
